// extracted by mini-css-extract-plugin
module.exports = {"inlineLogo":"inlineLogo_inlineLogo__ezf5W","listItem":"inlineLogo_listItem__OFTPs"};